import script from "./PaymentMethodEmail.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentMethodEmail.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentMethodEmail.vue?vue&type=style&index=0&id=3ac9cdc8&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac9cdc8"]])

export default __exports__